import { render, staticRenderFns } from "./BranchRegionMailsModalComponent.vue?vue&type=template&id=2c9a641e&scoped=true"
import script from "./BranchRegionMailsModalComponent.vue?vue&type=script&lang=js"
export * from "./BranchRegionMailsModalComponent.vue?vue&type=script&lang=js"
import style0 from "./BranchRegionMailsModalComponent.vue?vue&type=style&index=0&id=2c9a641e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9a641e",
  null
  
)

export default component.exports